import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { confirmPasswordValidator } from "src/app/utils/confirmPasswordValidator";
import { MyErrorStateMatcher } from "src/app/utils/requireMatch";

@Component({
  selector: "app-modal-password",
  templateUrl: "./pass-modal.component.html",
  styles: ["::ng-deep .mat-input-underline {display: none;}"],
})
export class PasswordModal implements OnInit {
  @ViewChild("polizaInput", { static: false })
  public polizaInput: ElementRef;

  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  @Output() onsave = new EventEmitter<{ mode: string; value: any }>();

  list: any[] = [];
  realData: any[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<PasswordModal>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  filteredOptions: Observable<any[]>;
  matcher = new MyErrorStateMatcher();

  public ngOnInit() {
    this.buildForm();
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group(
      {
        password1: new FormControl("", [Validators.required]),
        password2: new FormControl("", [Validators.required]),
      },
      { validators: confirmPasswordValidator }
    );
  }
  save() {
    const data = this.form.value;
    this.dialogRef.close(data);
  }
}
